<template>
  <v-layout align-center justify-center>
    <v-card class="elevation-12">
      <v-toolbar color="color.base1" dark>
        <v-toolbar-title>パスワードリセット</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <p>
          パスワードをリセットします。<br />
          ログイン用のメールアドレスを入力してください。
        </p>
        <v-text-field
          v-model="email"
          @keyup.enter="sendEmail"
          prepend-icon="person"
          name="email"
          label="メールアドレス"
          color="color.base1"
          type="text"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <ExecAndCancelButtons
          :loading="loading"
          @clickExec="sendEmail"
          @clickCancel="$router.push('/').catch(() => {})"
          exec-text="送信"
        />
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          パスワードリセットURL送信完了
        </v-card-title>
        <v-card-text>
          入力いただいたアドレスにメールをお送りしました。<br />
          メールに記載のURLからパスワードリセットを行ってください。
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click.prevent="$router.push('/').catch(() => {})"
            color="primary"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { actions as drawerActions } from '@/vuex/modules/ui/drawer/constants'
import ExecAndCancelButtons from '@/components/Shared/CrudUI/ExecAndCancelButtons.vue'
// todo model化
import Account from '@/api/account'

export default {
  name: 'InputEmailToResetPassword',
  components: { ExecAndCancelButtons },
  data() {
    return {
      email: '',
      dialog: false,
      loading: false,
    }
  },
  created() {
    this.$store.dispatch(drawerActions.CHANGE_DRAWER_TOGGLE_BUTTON_VISIBILITY, {
      flag: false,
    })
  },
  methods: {
    async sendEmail() {
      const requestBody = { email: this.email }
      this.loading = true
      try {
        await Account.postResetPasswordToken(requestBody)
      } catch (e) {
        this.loading = false
        const err = new Error(
          'メール送信に失敗しました。メールアドレスをご確認ください。',
        )
        throw err
      }
      this.dialog = true
    },
  },
}
</script>
